import React, {useEffect, useState} from "react";
import {Image, View, useTheme, Text, Heading, Flex, useAuthenticator} from "@aws-amplify/ui-react";
import {Link} from 'react-router-dom';
import {useLocation, useNavigate} from "react-router";
import coachingLogoWhite from '../../assets/images/logo/logo-white.svg';
import styles from "./index.module.css";
import {MyForm as RegisterForm} from "../../components/RegisterForm";
import Footer from "../../components/NoAuth/Footer";
import {register} from "../../data/api";
import GlobalAlert from "../../components/GlobalAlert";
import {translateRegisterErrorMessages} from "../../utils";

export default function Register() {
  const [error, setError] = useState();

  const {route} = useAuthenticator((context) => [context.route]);
  const location = useLocation();
  const navigate = useNavigate();
  let from = location.state?.from?.pathname || '/';

  useEffect(() => {
    if (route === 'authenticated') {
      navigate(from, {replace: true});
    }
  }, [route, navigate, from]);

  const mainFlexClassNames = ["auth-wrapper", styles.mainFlex];
  const {tokens: themeTokens} = useTheme();

  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get('token') || null;
  const email = urlParams.get('email') || null;

  const onSubmit = fields => {
    register(fields)
      .then(res => {
        const {
          result = true,
          message,
        } = res || {};

        if (result) {
          navigate('/registrazione/grazie');
          return;
        }

        setError(message);
      })
      .catch(setError);
  }

  return (
    <Flex
      direction="row"
      justifyContent="center"
      className={mainFlexClassNames.join(" ")}
    >
      <View
        className={styles.contentView}
      >
        {/*header logo*/}
        <View textAlign="center" padding={themeTokens.space.large}>
          <Image
            alt="Myedu logo"
            src={coachingLogoWhite}
          />
        </View>

        {/*main section*/}
        <View className={styles.registerWrapper}>
          <Heading
            padding={`0 0 ${themeTokens.space.xl} 0`}
            level={3}
          >
            Completa la tua registrazione su MyEdu Coaching
          </Heading>

          {
            !!error &&
            <GlobalAlert
              variation="error"
              style={{
                marginBottom: "16px",
                minWidth: "-webkit-fill-available",
              }}
              heading={translateRegisterErrorMessages(error)}
            />
          }

          <RegisterForm
            onSubmit={onSubmit}
            defaultEmail={email}
            defaultToken={token}
          />

          <Text
            style={{
              paddingTop: themeTokens.space.large,
              textAlign: "center",
            }}
          >
            Sei già registrato?
            {' '}
            <Link
              to="/login"
              style={{
                color: '#9381ff',
              }}
            >
              Accedi
            </Link>
          </Text>
        </View>

        {/*footer text*/}
        <Footer/>
      </View>
    </Flex>
  )
}
